import script from "./ConfirmPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmPassword.vue?vue&type=style&index=0&id=fc246cf6&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc246cf6"]])

export default __exports__